import React from "react";
import {Container, createTheme, CssBaseline, ThemeProvider} from "@mui/material";
import Typography from "@mui/material/Typography";
import {School} from "@mui/icons-material";

const theme = createTheme({
    typography: {
        fontFamily: [
            'Open Sans Condensed',
            'sans-serif'
        ].join(',')
    },
});

export const StudyHeader = () => {
    return (
        <ThemeProvider theme={theme}>
            <div style={{ textAlign: 'center'}}>
                <CssBaseline />
                <Container maxWidth="sm" sx={{ mt: '3rem'}}>
                <Typography component="div" variant="h4" sx={{ mb: '1rem', textTransform: 'uppercase'}} color={'info'}>
                    Study Note <School fontSize={'large'} color={'info'}/>
                </Typography>
                </Container>
            </div>
        </ThemeProvider>
    )
}

